import { CanActivateFn } from '@angular/router';
import { AppConstants } from './app.constants';

export const authGuard: CanActivateFn = (route, state) => {
  const appSettings: any = (<any>window)[AppConstants.AppSettings];
  const token = localStorage.getItem('TCC.Token');
  if (token) {
    return true; 
  } else {
    window.location.href = `${appSettings.tccWebAppUrl}${AppConstants.TCCLogOnLabel}`;
    return false;  
  }
};
